// extracted by mini-css-extract-plugin
module.exports = {"item":"Internal_item__NZeDi","icon":"Internal_icon__2614Y","disabled":"Internal_disabled__3zDBg","chevron":"Internal_chevron__3Kwls"};